/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {FC, useEffect, useRef, useState} from 'react'
import {useFormik} from 'formik'
import {usePageData} from '../../../layout/core'
import * as Yup from 'yup'
import {checkout, TPaymentOptions, uploadPaymentFile,} from '../../../../app/pages/balance/core/_requests'
import {FormattedMessage, useIntl} from 'react-intl'
import {Modal} from 'react-bootstrap'
import {useQueryClient} from 'react-query'
import {QUERIES} from '../../../helpers'
import {useAuth} from '../../../../app/modules/auth'
import Options from './Options'
import {FileInput} from '../../../../app/modules/custom/form-elements/file-inputs/FileInput'
import {ISetFieldValue} from '../../../helpers/custom/tsHelpers/generalHelpers'
import {handleFileUpload} from '../../../helpers/custom/funcs/handleFileUpload'
import {useLang} from '../../../i18n/Metronici18n'
import {allMessages} from '../../../i18n/i18nProvider'
import {Elements} from '@stripe/react-stripe-js'
import {stripeGetPromise} from '../../../../app/modules/payment/stripe/stripeConfig'
import StripePaymentForm from './StripePaymentForm'
import {NmiPayments, NmiPaymentsRef, NmiThreeDSecure, NmiThreeDSecureRef, PaymentInformation} from '@nmipayments/nmi-pay-react'
import appearance from '../../../helpers/custom/nmiAppearance'
import scrollToFieldError from '../../../../app/pages/tracks/_modals/one-page/ScrollToFieldError'

export const checkoutSchema = (intl: any) => Yup.object().shape({
  paymentOption: Yup.string(),
  sum: Yup.number().required(intl.messages.YUP_VALIDATION_PAYMENT_ENTER_SUM).positive(intl.messages.YUP_VALIDATION_PAYMENT_ENTER_SUM),
  comment: Yup.string(),
})
const CheckoutModalOptions: FC = () => {
  const queryClient = useQueryClient()
  const paymentOptions: TPaymentOptions = queryClient.getQueryData(QUERIES.PAYMENT_OPTIONS) || {}

  const paymentComponent = useRef<NmiPaymentsRef>(null)
  // const threeDSRef = useRef<NmiThreeDSecureRef>(null)

  // state hooks
  const [submitted, setSubmitted] = useState(false)
  const [isValid, setIsValid] = useState<boolean>(false);
  const [paymentToken, setPaymentToken] = useState<string>('');
  const [googleMerchant, setGoogleMerchant] = useState<IGoogleMerchant | null>(null)
  const [total, setTotal] = useState<{sum: string, pSum: string, charity: string, total: string}>({sum: '0', pSum: '0', charity: '0', total: '0'})

  // other hooks
  const {pageCustomData, setPageCustomData, addNotification} = usePageData()
  const {currentUser} = useAuth()
  const locale = useLang()
  const intl = useIntl()

  // handle document
  const [docIsLoading, setDocIsLoading] = useState(false)

  const saveDoc = async (e: React.ChangeEvent<HTMLInputElement>, setFieldValue: ISetFieldValue) => {
    setDocIsLoading(true)

    await handleFileUpload(e, setFieldValue, 'file', 'file', uploadPaymentFile, true)

    setDocIsLoading(false)
  }

  const deleteDoc = async (setFieldValue: ISetFieldValue) => {
    setFieldValue('file', '')
  }

  const stripeFormRef = React.useRef(null)

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      paymentOption: Object.keys(paymentOptions)[0],
      sum: pageCustomData?.checkoutSum || '',
      sumHrv: paymentOptions && pageCustomData?.checkoutSum ? +pageCustomData?.checkoutSum * +paymentOptions[Object.keys(paymentOptions)[0]]?.currencies?.usd || '' : '',
      debts: pageCustomData?.debts,
      comment: '',
      payment_token: '',
      file: {base_url: '', filename: ''},
      charity: {round: false, amount: ''},
    },
    validationSchema: checkoutSchema(intl),

    onSubmit: async (values) => {
      if (values.paymentOption === 'nmi') {
        try {
          // console.log('submit nmi', values)
          // @ts-ignore
          // window.CollectJS?.startPaymentRequest()
          if (!isValid || !paymentToken) return
          formik.setSubmitting(false)
          setSubmitted(true)
          //
          // const paymentInfo: PaymentInformation = {
          //   currency: 'USD',
          //   amount: total.total as string,
          //   firstName: currentUser?.firstName || '',
          //   lastName: currentUser?.lastName || '',
          //   paymentToken: paymentToken,
          // }

          // threeDSRef.current?.startThreeDSecure(paymentInfo)
        } catch (ex) {
          console.error(ex)
        }
      } else if (values.paymentOption === 'stripe') {
        if (stripeFormRef.current) {
          // @ts-ignore
          const success = await stripeFormRef.current.processPayment()
          if (success) {
            setSubmitted(true)
          }
        }
      } else {
        setSubmitted(true)
      }

    },
  })
  useEffect(() => {
    const {sum, comment, paymentOption, file, charity} = formik.values

    if (submitted && formik.values.sum > 0)
      checkout({
        sum: parseFloat(sum as string),
        comment,
        payment_token: paymentToken,
        provider: paymentOption,
        debts: pageCustomData?.debts,
        file: file.filename,
        charity: parseFloat(charity.amount as string),
      }).then((data) => {
        console.log('data ch', data)

        if (data.success) {
          formik.setStatus(false)
          setPageCustomData({checkoutShow: false, checkoutSum: ''})
          if (pageCustomData?.confirmRequest && pageCustomData?.confirmId) {
            pageCustomData?.confirmRequest(pageCustomData?.confirmId)
          }
          queryClient.invalidateQueries(QUERIES.BALANCE_CURRENT)
          queryClient.invalidateQueries(QUERIES.BALANCE_LIST)

          addNotification({
            header: 'GENERAL.DONE_TAB',
            body: 'GENERAL.TOOLTIPS.SUCCESSFUL_PAYMENT',
          })
          if (data.google_merchant) {
            setGoogleMerchant(data.google_merchant)
          }
          formik.resetForm()
        } else {
          paymentComponent.current?.resetFields()
          formik.setStatus(data.err)
          setTimeout(() => {
            document
              .getElementById('payment-status')
              ?.scrollIntoView({behavior: 'smooth', block: 'center'})
          }, 100)
        }
        setSubmitted(false)
      })
  }, [formik.values, submitted])

  const finishSubmit = (response: any) => {
    console.log('res ch', response)
    formik.setFieldValue('payment_token', response.token)

    formik.setSubmitting(false)
    setSubmitted(true)
  }
  const timeout = () => {
    formik.setFieldValue('payment_token', '')
    formik.setSubmitting(false)
    setSubmitted(true)
  }

  // useEffect(() => {
    // if (pageCustomData?.checkoutShow)
      // @ts-ignore
      // window.CollectJS?.configure({
      //   variant: 'inline', invalidCss: {
      //     color: '#B40E3E',
      //   }, validCss: {
      //     color: '#14855F',
      //   }, validationCallback: function(field: string, status: any, message: string) {
      //     setCDV((prev) => ({...prev, [field]: !!status}))
      //   },
      //   timeoutDuration: 10000,
      //   timeoutCallback: timeout,
      //   customCss: {
      //     'background-color': 'transparent', border: 'transparent', height: '100%',
      //   },
      //   styleSniffer: true, callback: (response: any) => {
      //     finishSubmit(response)
      //   },
      //   fields: {
      //     ccnumber: {
      //       placeholder: intl.formatMessage({id: 'PAYMENT.FORM.CC_NUMBER'}), selector: '#ccnumber',
      //     },
      //     ccexp: {
      //       placeholder: intl.formatMessage({id: 'PAYMENT.FORM.CC_EXPIRATION'}), selector: '#ccexp',
      //     },
      //     cvv: {
      //       placeholder: intl.formatMessage({id: 'PAYMENT.FORM.CVV'}), selector: '#cvv',
      //     },
      //   },
      //   country: 'US',
      //   currency: 'USD',
      //   price: '1.00'
      // })
  // }, [pageCustomData?.checkoutShow])

  useEffect(() => {
    if (googleMerchant && locale) {
      const {order_id, merchant_id, email, estimated_delivery_date, delivery_country} = googleMerchant
      const loadGCRScript = () => {
        window.renderOptIn = function () {
          window?.gapi?.load('surveyoptin', function () {
            window?.gapi?.surveyoptin.render({
              order_id, merchant_id, email, estimated_delivery_date, delivery_country, opt_in_style: 'CENTER_DIALOG',
            })
          })
        }

        window.___gcfg = {
          lang: allMessages[locale]?.fullLocale,
        }
        const script = document.createElement('script')
        script.src = 'https://apis.google.com/js/platform.js?onload=renderOptIn'
        script.async = true
        script.defer = true

        document.body.appendChild(script)

        return () => {
          document.body.removeChild(script)
          delete window.renderOptIn
          delete window.___gcfg
        }
      }

      const cleanup = loadGCRScript()
      return cleanup
    }
  }, [googleMerchant])
  const getAmounts = (amount: number, cIsOn = false) => {
    const percent = paymentOptions[formik.values.paymentOption]?.fee
    const fee = 1 + (percent || 0) / 100
    const under_fee = 1 - (percent || 0) / 100
    const sum = (+amount) * fee
    const round = (cIsOn && (sum - Math.floor(sum) >= 0.5)) ? Math.round(sum) - sum : 0
    const charity = round * under_fee
    return {fee, sum, charity}
  }
  useEffect(() => {
    if (formik.values.paymentOption === 'nmi') {
      let {sum, charity, fee} = getAmounts(+formik.values.sum, formik.values.charity.round)
      const {charity: pCharity} = getAmounts(+formik.values.sum, true)
      if (+formik.values.charity.amount < 0.5) {
        formik.setFieldValue('charity.amount', charity.toFixed(2))
      } else {
        charity = +formik.values.charity.amount
      }
      if (!formik.values.charity.round) charity = 0
      const result = (+formik.values.sum + charity) * fee
      const pSum = (+formik.values.sum + pCharity) * fee
      setTotal({
        sum: sum.toFixed(2), pSum: pSum.toFixed(2), charity: pCharity.toFixed(2), total: result.toFixed(2),
      })
    }
  }, [formik.values.paymentOption, formik.values.sum])
  useEffect(() => {
    if (formik.values.paymentOption === 'nmi') {
      const {sum, fee} = getAmounts(+formik.values.sum, formik.values.charity.round)
      const {charity: pCharity} = getAmounts(+formik.values.sum, true)
      const result = (+formik.values.sum + +formik.values.charity.amount) * fee
      const pSum = (+formik.values.sum + pCharity) * fee
      setTotal({
        sum: sum.toFixed(2), pSum: pSum.toFixed(2), charity: pCharity.toFixed(2), total: result.toFixed(2),
      })
    }
  }, [formik.values.charity.amount])

  const handleClose = () => setPageCustomData((prev: any) => ({...prev, checkoutShow: false}))

  return (
    <Modal show={pageCustomData?.checkoutShow} onHide={handleClose} backdrop='static'>
      <Modal.Header closeButton className='py-4'>
        <Modal.Title className='d-flex flex-column justify-content-start align-items-start'>
          <FormattedMessage id='PAYMENT.ADD_BUTTON' />
          <p className='d-block fw-normal fs-6 m-0'>
            <FormattedMessage
              id={`PAYMENT.FEE_NOTIFICATION.${formik?.values?.paymentOption?.toUpperCase()}`}
              values={{comm: paymentOptions[formik?.values?.paymentOption]?.fee || 0}}
              defaultMessage={' '}
            />
          </p>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Options formik={formik} />
        {formik.status && (
          <div id='payment-status' className='alert alert-danger'>
            {formik.status}
          </div>
        )}

        <form onSubmit={formik.handleSubmit} id='kt_checkout_form'>
          {(formik.values.paymentOption === 'fop' || formik.values.paymentOption === 'card') && (
            <div className='row mb-3'>
              <label className='col-lg-4 col-form-label fw-bold fs-6'></label>{' '}
              <div className='col-lg-8 position-relative d-flex flex-column'>
                <input
                  type='text'
                  className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                  placeholder='0.00'
                  {...formik.getFieldProps('sumHrv')}
                  onChange={(event) => {
                    formik.setFieldValue('sumHrv', event.target.value.replace(/,/g, '.'))

                    formik.setFieldValue(
                      'sum',

                      parseFloat(
                        (
                          +event.target.value.replace(/,/g, '.') /
                          +paymentOptions[formik.values.paymentOption]?.currencies?.usd
                        )
                          .toFixed(2)
                          .toString()
                      )
                    )
                  }}
                />

                <span
                  className={`fs-6 fw-normal position-absolute`}
                  style={{
                    left: '80%',
                    top: '50%',
                    transform: 'translateY(-50%)',
                  }}
                >
                  ₴
                </span>
                {formik.touched.sumHrv && formik.errors.sumHrv && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>{formik.errors.sumHrv}</div>
                  </div>
                )}
              </div>
            </div>
          )}{' '}
          <div className='row'>
            <label className='col-lg-4 col-form-label required fw-bold fs-6'>
              <FormattedMessage id='PAYMENT.FORM.SUM' />
            </label>

            <div className='col-lg-8 position-relative d-flex flex-column'>
              <input
                type='text'
                className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                placeholder='0.00'
                {...formik.getFieldProps('sum')}
                onChange={(event) => {
                  const sum = event.target.value.replace(/,/g, '.')
                  formik.setFieldValue('sum', sum)

                  formik.setFieldValue(
                    'sumHrv',

                    parseFloat(
                      (+sum * +paymentOptions[formik.values.paymentOption]?.currencies?.usd)
                        .toFixed(2)
                        .toString()
                    )
                  )
                }}
              />
              <span
                className={`fs-6 fw-normal position-absolute`}
                style={{
                  right: '10%',
                  top: '50%',
                  transform: 'translateY(-50%)',
                }}
              >
                $
              </span>
              {formik.touched.sum && formik.errors.sum && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>{formik.errors.sum}</div>
                </div>
              )}
            </div>
          </div>
          {pageCustomData?.showPayAll === true && currentUser?.balance && currentUser?.balance < 0 && (
            <div className='row'>
              <div className='col-lg-8 offset-lg-4'>
                <div className='row d-flex justify-content-center'>
                  <button
                    type='button'
                    className='text-gray-400 btn btn-sm text-hover-primary ps-0'
                    onClick={() => {
                      setPageCustomData({
                        ...pageCustomData,
                        checkoutSum: Math.abs(currentUser?.balance || 0),
                      })
                    }}
                  >
                    <FormattedMessage id='PAYMENT.FORM.PAY_DEBT' /> $
                    {Math.abs(currentUser?.balance || 0)}
                  </button>
                </div>
              </div>
            </div>
          )}
          <div className={formik.values.paymentOption !== 'nmi' ? 'd-none' : ''}>
            <div className='my-3 text-muted text-end'>
              <FormattedMessage id='PAYMENT.FORM.TOTAL' /> ${total.sum}
            </div>
            {paymentOptions[formik.values.paymentOption]?.charity && (
              <div className='my-3'>
                <div id='charity_options' className='fs-6'>
                  <div className='row mb-3'>
                    <div className='col-lg-12 position-relative d-flex flex-column'>
                      <div className='form-check'>
                        <input
                          className='form-check-input'
                          type='checkbox'
                          name='paymentOption'
                          id='paymentOption'
                          value={1}
                          checked={formik.values.charity.round}
                          onChange={(e) => {
                            formik.setFieldValue('charity.round', e.target.checked)
                            const {charity} = getAmounts(+formik.values.sum, e.target.checked)
                            formik.setFieldValue('charity.amount', charity.toFixed(2))
                          }}
                        />
                        <label className='d-flex align-items-center me-2' htmlFor='paymentOption'>
                          <span className='d-flex flex-column'>
                            <span className='fw-bolder fs-6'>
                              <FormattedMessage
                                id='PAYMENT.FORM.CHARITY_ROUND'
                                values={{total: total.pSum, charity: total.charity}}
                              />
                            </span>
                          </span>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className={`row ${formik.values.charity.round || 'd-none'}`}>
                    <label className='col-lg-4 col-form-label fw-bold fs-6'>
                      <FormattedMessage id='PAYMENT.FORM.CHARITY_LABEL' />
                    </label>
                    <div className='col-lg-8 position-relative d-flex flex-column'>
                      <label
                        className='d-flex position-relative fs-5 flex-column fw-bold mb-2'
                        htmlFor='charity.amount'
                      >
                        <input
                          type='number'
                          className='form-control form-control-lg form-control-solid'
                          {...formik.getFieldProps('charity.amount')}
                        />
                        <span className='fs-6 fw-normal InputTemplate_addSymbol'>$</span>
                      </label>
                      <div className='d-flex flex-row justify-content-center'>
                        {[1, 5, 10].map((sum) => (
                          <button
                            key={sum}
                            type='button'
                            className='text-gray-400 btn btn-sm text-hover-primary'
                            onClick={() => {
                              formik.setFieldValue('charity.amount', sum)
                            }}
                          >
                            ${sum}
                          </button>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {process.env.REACT_APP_NMI_PUBLIC_TOKEN ? (
              <div className='mb-3' data-token={process.env.REACT_APP_NMI_PUBLIC_TOKEN}>
                <NmiPayments
                  ref={paymentComponent}
                  tokenizationKey={process.env.REACT_APP_NMI_PUBLIC_TOKEN}
                  layout='multiLine'
                  paymentMethods={['card', 'google-pay', 'apple-pay']}
                  appearance={appearance}
                  onChange={(data) => {
                    setIsValid(data.complete)

                    if (data.complete && data.token) {
                      setPaymentToken(data.token)
                    }
                    // console.log('onChange', data)
                  }}
                  onExpressCheckout={async (data) => {
                    console.log('NMI express checkout args', data)

                    if (!data.token) return
                    setPaymentToken(data.token)
                    setTimeout(() => {
                      formik.setSubmitting(false)
                      setSubmitted(true)
                    }, 100)
                    return ''
                  }}
                  expressCheckoutConfig={{
                    amount: parseFloat(total.total) > 0 ? total.total : '1.00',
                    applePay: {},
                    billingRequired: false,
                    currency: 'USD',
                    emailRequired: false,
                    googlePay: {
                      buttonType: 'short',
                    },
                    phoneRequired: false,
                    shippingRequired: false,
                  }}
                  onFieldsAvailable={() => {
                    // console.log('onFieldsAvailable')
                  }}
                />
                {/* 3D Secure component */}
                {/*<NmiThreeDSecure*/}
                {/*  ref={threeDSRef}*/}
                {/*  tokenizationKey={process.env.REACT_APP_NMI_PUBLIC_TOKEN}*/}
                {/*  modal={true}*/}
                {/*  onComplete={(result) => {*/}
                {/*    console.log('3DS authentication complete:', result)*/}

                {/*    finishSubmit(result)*/}
                {/*  }}*/}
                {/*  onFailure={(error) => {*/}
                {/*    // Called when 3DS authentication fails*/}
                {/*    formik.setStatus(error.message)*/}
                {/*  }}*/}
                {/*  onChallenge={() => {*/}
                {/*    // Called when 3DS challenge is triggered*/}
                {/*  }}*/}
                {/*/>*/}
              </div>
            ) : null}
          </div>{' '}
          {formik.values.paymentOption === 'stripe' && (
            <Elements
              stripe={stripeGetPromise(paymentOptions['stripe'].key)}
              options={{
                mode: 'payment',
                amount: Math.round((+formik.values.sum || 1) * 100), // shd be in cents
                currency: 'usd',
                appearance: {
                  theme: 'stripe',
                },
              }}
            >
              <StripePaymentForm
                formik={formik}
                innerRef={stripeFormRef}
                setSubmitted={setSubmitted}
              />
            </Elements>
          )}
          {paymentOptions[formik.values.paymentOption]?.optional_fields?.file && (
            <div className='pt-5 w-100'>
              {' '}
              <FileInput
                inputName='file'
                inputId='payment-file'
                setFieldValue={formik.setFieldValue}
                uploadedFile={{
                  base: formik.values?.file?.base_url || '',
                  link: formik.values?.file?.filename || '',
                }}
                uploadFunction={saveDoc}
                deleteFunction={deleteDoc}
                loading={docIsLoading}
                formikHook={false}
              />
            </div>
          )}
          <div className='row mb-3'>
            <label className='form-label fw-bold fs-6'>
              <FormattedMessage id='PAYMENT.FORM.COMMENT' />
            </label>

            <div className='col-lg-12'>
              <textarea
                rows={3}
                className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                {...formik.getFieldProps('comment')}
              />
              {formik.touched.comment && formik.errors.comment && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>{formik.errors.comment}</div>
                </div>
              )}
            </div>
          </div>
        </form>
        {/* {JSON.stringify(isValid)} */}
      </Modal.Body>
      <Modal.Footer>
        <button
          type='button'
          className='btn btn-secondary fw-bold'
          disabled={formik.isSubmitting}
          onClick={handleClose}
        >
          <FormattedMessage id='GENERAL.BUTTONS.CLOSE' />
        </button>
        <button
          id='kt_checkout_submit'
          form='kt_checkout_form'
          type='submit'
          className='btn btn-primary fw-bold'
          disabled={formik.isSubmitting || (formik.values.paymentOption === 'nmi' && !isValid)}
        >
          {!formik.isSubmitting && (
            <FormattedMessage
              id='GENERAL.BUTTONS.CONFIRM_PAYMENT'
              values={{sum: formik.values.paymentOption === 'nmi' ? `$${total.total}` : null}}
            />
          )}
          {formik.isSubmitting && (
            <span className='indicator-progress' style={{display: 'block'}}>
              <FormattedMessage id='GENERAL.BUTTONS.WAIT' />
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
      </Modal.Footer>
    </Modal>
  )
}

export {CheckoutModalOptions}
